import React from 'react';
import { BrowserRouter, Routes, Route, NavLink, Navigate } from 'react-router-dom';
import LicenseTable from './features/LicenseTable';
import BatchImportForm from './BatchImportForm';
import CreateLicenseForm from './CreateLicenseForm';
import CustomersList from './features/Customers/CustomersList';
import CustomerDetail from './features/Customers/CustomerDetail';
import { useAuth } from "react-oidc-context";
import { Button } from './components/Button';
import './App.css';

function App() {
  const auth = useAuth();

  const signOutRedirect = () => {
    const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
    const logoutUri = process.env.REACT_APP_LOGOUT_URI;
    const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN;

    if (!clientId || !logoutUri || !cognitoDomain) {
      console.error("Logout configuration environment variables are missing!");
      auth.signoutSilent();
      return;
    }
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  };

  const handleLicenseCreated = () => {
    console.log("License created - potential table refresh hook");
  };

  const handleBatchComplete = (results) => {
    console.log("Batch processing completed:", results);
  };

  if (auth.isLoading) {
    return (
      <div className="app-splash">
        <p className="app-splash__text">Loading authentication…</p>
      </div>
    );
  }

  if (auth.error) {
    return (
      <div className="app-splash">
        <div className="app-card" role="alert">
          <h2 className="app-card__title">Authentication Error</h2>
          <p className="app-card__message">{auth.error.message}</p>
          <Button variant="primary" onClick={() => auth.signinRedirect()}>Try Sign in again</Button>
        </div>
      </div>
    );
  }

  if (auth.isAuthenticated) {
    return (
      <BrowserRouter>
        <div className="app-shell">
          <div className="app-shell__user-bar">
            <p className="app-shell__hello">Hello: {auth.user?.profile?.email || auth.user?.profile?.sub}</p>
            <Button variant="ghost" size="sm" onClick={signOutRedirect}>Sign out</Button>
          </div>
          <h1 className="app-shell__title">aiTriage v1 License Management</h1>
          <nav className="app-nav">
            <NavLink to="/customers">Customers</NavLink>
            <NavLink to="/devices">All Devices</NavLink>
            <NavLink to="/import">Create / Import</NavLink>
          </nav>
          <Routes>
            <Route path="/" element={<Navigate to="/customers" replace />} />
            <Route path="/customers" element={<CustomersList />} />
            <Route path="/customers/:customerNumber" element={<CustomerDetail />} />
            <Route path="/devices" element={<LicenseTable />} />
            <Route path="/import" element={
              <>
                <CreateLicenseForm onLicenseCreated={handleLicenseCreated} />
                <BatchImportForm onBatchComplete={handleBatchComplete} />
              </>
            } />
            <Route path="*" element={<Navigate to="/customers" replace />} />
          </Routes>
        </div>
      </BrowserRouter>
    );
  }

  return (
    <div className="app-splash">
      <div className="app-card app-card--welcome">
        <h2 className="app-card__title">Welcome to aiTriage v1 License Management</h2>
        <p className="app-card__message">Please sign in to continue.</p>
        <Button variant="primary" onClick={() => auth.signinRedirect()}>Sign in</Button>
      </div>
    </div>
  );
}

export default App;
